import { useQuery } from '@tanstack/react-query';

import { api } from '../client';
import { queryKeys, PENDING_POLL_MS } from './keys';
import type { Dashboard } from '../types';

/** The dashboard's own counts; refreshes while any of the viewer's ideas is in research. */
export function useDashboard() {
  return useQuery({
    queryKey: queryKeys.dashboard,
    queryFn: () => api<Dashboard>('/api/dashboard'),
    refetchInterval: (query) => ((query.state.data?.mine.verdict_counts.researching ?? 0) > 0 ? PENDING_POLL_MS : false),
  });
}
